import { appendAPExamTemplate } from '@/functions/idp'
import RIC from './RIC_4'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
